export default __webpack_public_path__ + "static/media/gt.67214b0b.svg";